import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { companyQueryKeys } from "./companyQueryKeys";

export function useQueryCompany({ api }: { api: ApiType }) {
  return useQuery({
    queryKey: companyQueryKeys.all(),
    queryFn: async () => {
      return (await api.companyApi.details()).data;
    },
  });
}
